import { FC, ChangeEvent, CSSProperties } from 'react';

import { makeStyles, Tab, TabProps, Tabs, Theme } from '@material-ui/core';

const useStyles = makeStyles(
  (theme: Theme) => ({
    container: {
      display: 'flex',
      borderRadius: 24,
      background: theme.palette.bkg.primary,
      flexWrap: 'wrap',
    },
    tab: {
      padding: '6px 12px',
      position: 'relative',
      fontWeight: 500,
      cursor: 'pointer',
      textDecoration: 'none',
    },
    divider: {
      width: 2,
      background: theme.palette.blueGrey[200],
      display: 'block',
      alignSelf: 'center',
    },
    defaultTab: {
      color: theme.palette.text.primary,
      opacity: 1,
      fontWeight: 500,
      margin: '0 8px',
      minWidth: 0,
      padding: 0,
      letterSpacing: '0.009rem',
      fontSize: '1.125rem',
      '&:first-child': {
        marginLeft: 0,
      },
    },
    tabRoot: {
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
      },
    },
    selected: {
      color: theme.palette.primary.main,
    },
  }),
  { name: 'WbTabs' },
);

export interface WbTabProps {
  name: string;
}

interface WbTabsProps extends WbTabProps {
  selected?: boolean;
  tabProps?: TabProps;
}

interface Props {
  tabs: Array<WbTabsProps>;
  wrapperClassName?: string;
  containerClassName?: string;
  selectedClassName?: string;
  variant?: 'default';
  handleChange?: (_: ChangeEvent<{}>, newValue: number) => void;
  selectedTab?: any;
  tabStyle?: CSSProperties;
  scrollable?: boolean;
}

/**
 * @deprecated Use the non deprecated components from WbTabs instead
 */
export const WbTabsOld: FC<Props> = ({
  tabs,
  handleChange,
  selectedTab,
  tabStyle,
  scrollable = false,
}) => {
  const classes = useStyles();
  return (
    <Tabs
      selectionFollowsFocus
      indicatorColor="primary"
      aria-label="tabs"
      onChange={handleChange}
      value={selectedTab}
      style={tabStyle}
      variant={scrollable ? 'scrollable' : 'standard'}
      scrollButtons="auto"
    >
      {tabs.map((tab, index) => (
        <Tab
          {...tab.tabProps}
          data-testid={`header-tab-${index}`}
          label={tab.name}
          key={tab.name}
          value={index}
          className={classes.defaultTab}
          classes={{ selected: classes.selected, root: classes.tabRoot }}
        />
      ))}
    </Tabs>
  );
};
